<template>
    <div class="main_bg">
        <div class="item_info border_Warningcolor">
            <el-descriptions class="margin-top" title="充值记录详情" :column="3" border>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        订单号
                    </template>
                    {{ editForm.code }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        所属门店
                    </template>
                    {{ editForm.storeName }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        会员卡编号
                    </template>
                    {{ editForm.vipNo }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        经办人
                    </template>
                    {{ editForm.creator }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        经办时间
                    </template>
                    {{ editForm.createTime }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        充值状态
                    </template>
                    {{ editForm.stateStr }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        是否确认
                    </template>
                    {{ editForm.isConfirm ? '是' : '否' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        确认人
                    </template>
                    {{ editForm.confirmUserName }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        确认时间
                    </template>
                    {{ editForm.confirmTime }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        充值总额
                    </template>
                    {{ editForm.rechargeMoney }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        赠送金额
                    </template>
                    {{ editForm.bonusMoney }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        总支付金额
                    </template>
                    {{ editForm.totalPayMoney }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        欠款金额
                    </template>
                    {{ editForm.amountMoney }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        是否完成
                    </template>
                    {{ editForm.isConfirm ? '是' : '否' }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        完成时间
                    </template>
                    {{ editForm.finishedTime }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        是否有电话提成
                    </template>
                    {{ editForm.isPhoneBonus ? '是' : '否' }}
                </el-descriptions-item>
                <el-descriptions-item v-if="editForm.isPhoneBonus">
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        电话提成员工
                    </template>
                    {{ editForm.phoneBonusUserName }}
                </el-descriptions-item>
                <!-- <el-descriptions-item span="3">
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            备注
                        </template>
                        {{ editForm.remark }}
                    </el-descriptions-item> -->
            </el-descriptions>
        </div>
        <div class="item_info">
            <el-descriptions class="margin-top" title="顾客信息" :column="6" border>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-user"></i>
                        顾客姓名
                    </template>
                    {{ transformEmpty(customerInfo.name) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-office-building"></i>
                        性别
                    </template>
                    {{ transformGender(customerInfo.gender) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        年龄
                    </template>
                    {{ transformEmpty(customerInfo.age) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-mobile-phone"></i>
                        顾客电话
                    </template>
                    {{ transformEmpty(customerInfo.phone) }}
                </el-descriptions-item>
                <el-descriptions-item span="3">
                    <template slot="label">
                        <i class="el-icon-location-outline"></i>
                        所属门店
                    </template>
                    {{ transformEmpty(customerInfo.belongStoreName) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        (右眼)球镜
                    </template>
                    {{ transformEmpty(customerInfo.rParams.qiuJing) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        柱镜
                    </template>
                    {{ transformEmpty(customerInfo.rParams.zhuJing) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        轴位
                    </template>
                    {{ transformEmpty(customerInfo.rParams.zhouWei) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        瞳高
                    </template>
                    {{ transformEmpty(customerInfo.rParams.tongGao) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        瞳距
                    </template>
                    {{ transformEmpty(customerInfo.rParams.tongJu) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        矫正视力
                    </template>
                    {{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        (左眼)球镜
                    </template>
                    {{ transformEmpty(customerInfo.lParams.qiuJing) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        柱镜
                    </template>
                    {{ transformEmpty(customerInfo.lParams.zhuJing) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        轴位
                    </template>
                    {{ transformEmpty(customerInfo.lParams.zhouWei) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        瞳高
                    </template>
                    {{ transformEmpty(customerInfo.lParams.tongGao) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        瞳距
                    </template>
                    {{ transformEmpty(customerInfo.lParams.tongJu) }}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        矫正视力
                    </template>
                    {{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}
                </el-descriptions-item>
            </el-descriptions>
        </div>
        <div class="item_info border_Danger">
            <div class="item_title">
                <div class="title">支付记录</div>
                <div class="btnDiv">
                    <div class="btnDivItem">
                        会员类型：{{ customerInfo.customerTypeStr }}
                    </div>
                    |
                    <div class="btnDivItem">
                        档案编号：{{ customerInfo.customerNo }}
                    </div>
                </div>
            </div>
            <payRecord ref="payRecord"></payRecord>
        </div>
        <div class="item_info border_Danger">
            <div class="item_title">
                <div class="title">提成记录</div>
                <div class="btnDiv">
                </div>
            </div>
            <commissionRecord ref="commissionRecord"></commissionRecord>
        </div>
    </div>
</template>
<script>
import {
    GetVipRechargeHistoryDetail
} from "@/api/vipApi.js";
import {
    getCustomerInfoDetail
} from "@/api/baseDataApi.js";
import payRecord from "@/views/pay/record.vue";
import commissionRecord from "@/views/accounting/storeCost/commission/record.vue";
export default {
    props: [],
    data() {
        return {
            editForm: {
            },
            customerInfo: {
                name: "",
                phone: "",
                age: "",
                gender: -1,
                belongStoreName: "",
                lParams: {
                    qiuJing: "",
                    zhuJing: "",
                    zhouWei: "",
                    jiaoZhengShiLi: "",
                    tongJu: "",
                    tongGao: "",
                },
                rParams: {
                    qiuJing: "",
                    zhuJing: "",
                    zhouWei: "",
                    jiaoZhengShiLi: "",
                    tongJu: "",
                    tongGao: "",
                },
            },
        };
    },
    components: {
        payRecord,
        commissionRecord,
    },
    created() { },
    methods: {
        // 显示
        getDetail(row) {
            GetVipRechargeHistoryDetail({
                keyId: row.keyId,
            }).then((res) => {
                if (res.code == 1) {
                    getCustomerInfoDetail({ keyId: res.data.customerKeyId }).then(
                        (res) => {
                            if (res.code == 1) {
                                this.customerInfo = res.data;
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.msg,
                                });
                            }
                        }
                    );
                    this.editForm = res.data;
                    this.$refs.payRecord.showPayReord(row.keyId);
                    this.$refs.commissionRecord.showCommissionReord(row.keyId);
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        // 显示提成记录
        getCommissionDetail(row) {
            GetVipRechargeHistoryDetail({
                keyId: row.businessKeyId,
            }).then((res) => {
                if (res.code == 1) {
                    getCustomerInfoDetail({ keyId: res.data.customerKeyId }).then(
                        (res) => {
                            if (res.code == 1) {
                                this.customerInfo = res.data;
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.msg,
                                });
                            }
                        }
                    );
                    this.editForm = res.data;
                    this.$refs.payRecord.showPayReord(row.businessKeyId);
                    this.$refs.commissionRecord.showCommissionReord(row.businessKeyId);
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        //转换性别
        transformGender(gender) {
            if (gender == 1) {
                return "男";
            } else if (gender == 0) {
                return "女";
            } else {
                return "--";
            }
        },
        //判断为空则用 -- 替代
        transformEmpty(obj) {
            if (obj == "" || obj == null || obj == undefined) {
                obj = "--";
            }
            return obj;
        },
    },
};
</script>
<style scoped lang="scss">
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.border_Danger {
    border-left: 5px solid #ff0000;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;

    .title {
        display: inline-block;
        unicode-bidi: isolate;
    }

    .btnDiv {
        display: block;
        unicode-bidi: isolate;
        word-break: break-all;
    }

    .btnDivItem {
        display: inline-block;
    }

    .text-red {
        display: block;
        background-color: #ff0000;
    }
}
</style>